import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';

@Component({
  selector: 'app-depot-overview-card-loading-skeleton',
  imports: [LoadingSkeletonComponent],
  templateUrl: './depot-overview-card-loading-skeleton.component.html',
  host: {
    class:
      // eslint-disable-next-line max-len
      'flex justify-between pr-10 h-[224px] rounded-radius-cards bg-background-fixed drop-shadow-foreground-primary-20-shadow-30 dark:drop-shadow-foreground-secondary-20-shadow-30',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepotOverviewCardLoadingSkeletonComponent {
  public readonly statusSkeleton = Array.from({
    length: 7,
  }).map(() => ({}));
}
